































































import Vue from 'vue';
import CommunityComments from '@/web/components/community/CommunityComments.vue';
import CommunityCommentsSearch from '@/web/components/community/CommunityCommentsSearch.vue';
import { getStudioURL } from '@/web/router/custom-domain-utils';
import { mapGetters } from 'vuex';

export default Vue.extend({
  name: 'StudioCommunityFeed',
  components: {
    CommunityComments,
    CommunityCommentsSearch,
  },
  computed: {
    ...mapGetters({
      group: 'community/currentGroup',
      studioCommunityProfileId: 'studio/communityProfileId',
    }),
    studioURL() {
      return getStudioURL(this.$route);
    },
    groupName() {
      return this.group?.group_name;
    },
    query() {
      return this.$route.query.query;
    },
    hashtagsEnabled() {
      return this.group?.hashtags_enabled;
    },
    hashtags() {
      return this.group?.hashtags;
    },
    hasHashtags() {
      if (!this.hashtags) return false;
      return this.hashtags?.length > 0;
    },
  },
  methods: {
    onHashtag(hashtag) {
      this.$emit('onHashtag', hashtag);
    },
  },
});
